<template>
  <div class="page" ref="container">
    <nav-bar
      title="服务卡项"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      :fixed="false"
      :placeholder="true"
    />

    <div class="combo-list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="list acea-row">
          <img src="@assets/images/def_service.jpg" v-if="!item.itemPic" />
          <img :src="item.itemPic + '!tmb_130'" v-else />
          <div class="item-name-wrap">
            <div class="name">
              <span class="title">{{ item.itemName }}</span>
              <span class="num">剩余次数:{{ item.num }}</span>
            </div>
            <div class="li">时长：{{ item.elapsed || 0 }}分钟</div>
            <div class="li">有效期至：{{ formatDate(item.expireAt) }}</div>
          </div>
        </div>
      </div>
      <empty description="暂无优惠卡项" v-if="list.length === 0" />
    </div>
  </div>
</template>
<script>
import { NavBar, Empty } from "vant";
import { getCombo } from "@api/member";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  components: {
    NavBar,
    Empty,
  },
  props: {},
  data: function () {
    return {
      types: "",
      phone: 18874039896,
      list: [],
      loaded: false,
      loading: false,
    };
  },
  mounted: function () {
    let that = this;
    that.getIndex();
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.getIndex();
      },
    },
  },
  methods: {
    formatDate(time) {
      return dayjs.unix(time).format("YYYY-MM-DD HH:mm:ss");
    },
    getIndex: function () {
      let that = this;
      getCombo().then((res) => {
        that.list = res.result;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  .combo-list {
    background-color: #fff;
    font-size: 0.24rem;
    color: #999;
    margin: 5px 0;

    .list {
      border-bottom: 0.5px solid #eee;
      margin-left: 15px;
      margin-bottom: 5px;
      padding: 10px 0;

      .item-name-wrap {
        margin-left: 10px;
        font-size: 0.24rem;
        flex: 1;

        .name {
          display: flex;
          justify-content: space-between;
          color: #282828;
          margin-bottom: 5px;
          font-size: 0.28rem;

          .num {
            font-size: 0.26rem;
            width: 100px;
            text-align: right;
            color: #fc4141;
            margin-right: 10px;
          }
        }
        .li {
          line-height: 0.365rem;
        }
      }

      img {
        border: 1px solid #c3cbd6;
        border-radius: 4px;
        width: 1.2rem;
        height: 1.2rem;
      }
    }
  }
}
</style>
